<template>
	<div id="terms-of-purchase" class="lightbox">
		<button type="button" class="lightbox-close" @click="closeModal(true)">
			<i class="fas fa-times"></i>
		</button>
		<div class="lightbox-content">
			<div>
				<template>
					<div class="section your-information bg-white" id="">
						<div class="layout-form">
							<h2 style="margin-bottom:0px;">Billing Information</h2>
							<div class="two-column">
								<div class="column-1">
									<label>Billing First Name <em class="required">*</em></label>
									<input
											type="text"
											label="First Name"
											name="billing_firstname"
											id="billing_firstname"
											v-model="user.billing_firstname"
											required="required"
											@blur="validateField"
									/>
									<p class="message" v-if="msg.billing_firstname">
										{{ msg.billing_firstname }}
									</p>
								</div>
								<div class="column-2">
									<label>Billing Last Name <em class="required">*</em></label>
									<input
											type="text"
											label="Last Name"
											name="billing_lastname"
											id="billing_lastname"
											v-model="user.billing_lastname"
											required="required"
											@blur="validateField"
									/>
									<p class="message" v-if="msg.billing_lastname">
										{{ msg.billing_lastname }}
									</p>
								</div>
							</div>
							<div class="two-column">
								<div class="column-1">
									<label>Address<em class="required">*</em></label>
									<input
											type="text"
											label="Address"
											name="address"
											id="address"
											v-model="user.address"
											required="required"
											@blur="validateField"
									/>
									<p class="message" v-if="msg.address">{{ msg.address }}</p>
								</div>
								<div class="column-2">
									<label>Address 2</label>
									<input type="text" name="address2" id="address2" v-model="user.address2"/>
								</div>
							</div>
							<div class="two-column">
								<div class="column-1">
									<label>Country <em class="required">*</em></label>
									<select id="country-select" v-model="user.country" @change="userUpdatedCountry">
										<option value="">
											Select a Country
										</option>
										<option v-for="country in countries" :value="country.TwoDigit" :key="country.TwoDigit">
											{{ country.Name }}
										</option>
									</select>
									<p class="message" v-if="msg.country">{{ msg.country }}</p>
								</div>
								<div class="column-2">
									<label>State/Province<em class="required">*</em></label>
									<select id="state" v-model="user.state" label="City" @change="validateField">
										<option value="">
											Select a State
										</option>
										<option v-for="state in states" :value="state.StateCode" :key="state.StateCode">
											{{ state.Name }}
										</option>
									</select>
									<p class="message" v-if="msg.state">{{ msg.state }}</p>
								</div>
							</div>
							<div class="two-column">
								<div class="column-1">
									<label>City <em class="required">*</em></label>
									<input
											type="text"
											label="City"
											name="city"
											id="city"
											required="required"
											v-model="user.city"
											@blur="validateField"
									/>
									<p class="message" v-if="msg.city">{{ msg.city }}</p>
								</div>
								<div class="column-2">
									<label>Zip/Postal <em class="required">*</em></label>
									<input
											type="text"
											label="Postal Code"
											name="zip"
											id="zip"
											required="required"
											v-model="user.zip"
											@blur="validateField"
									/>
									<p class="message" v-if="msg.zip">{{ msg.zip }}</p>
								</div>
							</div>
						</div>
					</div>
				</template>
				<h3 v-if="orderPayment" class="information-msg">
					You will be charged ${{ orderPayment.value }} {{ order.currency }} now
				</h3>
				<h3 v-else class="information-msg">
					You will not be charged until your next installment date.
				</h3>
				<payment-form
						ref="paymentForm"
						:user="user"
						:order-id="order.id"
						:is-immediate-payment="!!orderPayment"
						@payment-token="onFormSubmittedWithToken"
						@validate-fields="onValidateFields"
				></payment-form>
				<payment-modal v-if="showPaymentResponseModal" @close="closeModal()">
					<template v-slot:header>
						<h3>{{ modalTitle }}</h3>
					</template>
					<template v-slot:body>
						<p v-if="modalMessage">{{ modalMessage }}</p>
					</template>
				</payment-modal>
			</div>
		</div>
	</div>
</template>

<script>
import PaymentForm from "./PaymentForm.vue"
import PaymentModal from "./PaymentResponseModal"
import axios from "axios"
import CountryHelper from "../country-helper.js"
import User from "@/model/user"

export default {
	components: {
		PaymentForm,
		PaymentModal
	},
	computed: {
		countries() {
			return this.countryHelper.All
		},
		states() {
			return this.user.country ? this.countryHelper.getStatesByCountryCode(this.user.country) : []
		}
	},
	props: {
		order: {
			required: false,
			default: {}
		},
		orderPayment: {
			required: false,
			default: null
		}
	},
	data: () => ({
		card: {},
		user: new User(),
		countryHelper: {},
		msg: {
			billing_firstname: null,
			billing_lastname: null,
			address: null,
			city: null,
			zip: null,
			country: null,
			state: null
		},
		showPaymentResponseModal: false,
		modalMessage: null,
		modalTitle: null,
		wasResponse200: false
	}),
	async mounted() {
		this.countryHelper = new CountryHelper()

		this.loadUser()
		this.onValidateFields()
	},
	methods: {
		loadUser() {
			this.user = new User()

			if (this.order) {
				this.user.billing_firstname = this.order.billing_firstname
				this.user.billing_lastname = this.order.billing_lastname
				this.user.address = this.order.billing_address
				this.user.address2 = this.order.billing_address2
				this.user.city = this.order.billing_city
				this.user.zip = this.order.billing_zip

				const countryHelper = new CountryHelper(this.order.billing_country)
				this.user.country = this.order.billing_country ? countryHelper.TwoDigit : ""

				const foundStateName = !!countryHelper.getStateNameByCode(this.order.billing_state)
				this.user.state = foundStateName ? this.order.billing_state : this.states.length ? this.states[0].StateCode : ""
			}
		},
		closeModal(isForceClose = false) {
			this.showPaymentResponseModal = false
			if (isForceClose || this.wasResponse200) {
				this.$emit("close")
				this.$emit("update-orders")
			}
		},
		onFormSubmittedWithToken(ccTokenized) {
			const payload = {
				token: ccTokenized,
				order: this.order.id,
				user: {
					billing_firstname: this.user.billing_firstname,
					billing_lastname: this.user.billing_lastname,
					billing_address: this.user.address,
					billing_address2: this.user.address2,
					billing_state: this.user.state,
					billing_country: this.user.country,
					billing_city: this.user.city,
					billing_zip: this.user.zip
				},
				confirm: window.portal.user.id.decode().encode()
			}

			axios.defaults.headers.common["X-Auth-Token"] = window.portal.session.token

			// Set url (update or paynow) for the request
			const urlSuffix = this.orderPayment
					? `payments/${this.orderPayment.id}/paynow`
					: "updateOrderFutureInstallmentsToken"
			axios
					.post(`${window.portal.api_server}/userportal/orders/${this.order.id}/${urlSuffix}`, payload)
					.then(async response => {
						if (response && response.status && response.status === 200) {
							this.showPaymentResponseModal = true
							this.modalTitle = this.orderPayment ? "Thank You" : "Payment Updated"
							this.modalMessage = this.orderPayment
									? "Successfully charged for this payment."
									: "Successfully updated payment method."
							this.wasResponse200 = true
						}
					})
					.catch(e => {
						this.showPaymentResponseModal = true
						this.modalTitle = "Error"
						let message = ""

						if (e.response && e.response.data && e.response.data.status && e.response.data.status.message) {
							message = e.response.data.status.message
						} else if (e.response && e.response.data && e.response.data.message) {
							message = e.response.data.message
						} else if (e.message) {
							message = e.message
						}
						this.modalMessage = message
						// Reset the button to allow retries
						this.$refs.paymentForm.disablePayButton = false
						this.$refs.paymentForm.resetSubmitText()
					})
					.finally(() => {
						this.$refs.paymentForm.isProcessing = false
					});
		},
		onValidateFields() {
			if (!this.user.billing_firstname) {
				this.msg["billing_firstname"] = `Please enter your First Name`
			}
			if (!this.user.billing_lastname) {
				this.msg["billing_lastname"] = `Please enter your Last Name`
			}
			if (!this.user.address) {
				this.msg["address"] = `Please enter your Address`
			}
			if (!this.user.country) {
				this.msg["country"] = `Please enter your Country`
			}
			if (!this.user.state) {
				this.msg["state"] = `Please enter your State`
			}
			if (!this.user.city) {
				this.msg["city"] = `Please enter your City`
			}
			if (!this.user.zip) {
				this.msg["zip"] = `Please enter your Postal Code`
			}
		},
		validateField(event) {
			if (event.target.value.length <= 0) {
				this.msg[event.currentTarget.id] = `Please enter the ${
						event.target.getAttribute("label") ? event.target.getAttribute("label") : event.currentTarget.name
				}`
			} else {
				this.msg[event.currentTarget.id] = ""
			}
		},
		userUpdatedCountry() {
			if (!this.user.country) {
				this.msg["country"] = `Please select a Country`
				
				this.user.state = null
			} else {
				this.msg["country"] = ""
				
				//Select the first state in the country by default	
				this.user.state = this.states ? this.states[0].StateCode : null
				this.msg["state"] = ``
			}
		},
	}
}
</script>